module.exports = __webpack_public_path__ + "static/media/bgRosario.4073d007.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/bgRosario.png
// module id = 1269
// module chunks = 0